import React from 'react';

interface VersionData {
  version: string;
  buildNumber: string;
  commitSha: string;
  buildDate: string;
}

const VersionInfo: React.FC<{ className?: string }> = ({ className = '' }) => {
  const versionInfo: VersionData = {
    version: process.env.REACT_APP_VERSION || 'dev',
    buildNumber: process.env.REACT_APP_BUILD_NUMBER || '0',
    commitSha: process.env.REACT_APP_COMMIT_SHA || 'unknown',
    buildDate: process.env.REACT_APP_BUILD_DATE || 'unknown'
  };

  return (
    <div className={`text-xs text-gray-500 ${className}`}>
      <div className="flex items-center space-x-2">
        <span>v{versionInfo.version}</span>
        <span>•</span>
        <span>Build #{versionInfo.buildNumber}</span>
        <span>•</span>
        <span title={`Commit: ${versionInfo.commitSha}`}>
          {versionInfo.commitSha.substring(0, 7)}
        </span>
        <span>•</span>
        <span title={versionInfo.buildDate}>
          {new Date(versionInfo.buildDate).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};

export default VersionInfo; 